import { armorAPI } from '~/services/api';

function createFilterGroup(payload: { name: string; filter_criteria: unknown[] }) {
  return armorAPI.request({
    url: 'orderviews/',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: payload,
  });
}

function getFilterGroups() {
  return armorAPI.request({
    url: 'orderviews/',
    method: 'GET',
  });
}

function deleteFilterGroup(filterGroupObjectID: string) {
  return armorAPI.request({
    method: 'DELETE',
    url: `orderviews/${filterGroupObjectID}/`,
  });
}

export { createFilterGroup, getFilterGroups, deleteFilterGroup };
